import { render } from "./TokenReset.vue?vue&type=template&id=a5d9b892"
import script from "./TokenReset.vue?vue&type=script&lang=js"
export * from "./TokenReset.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__